<template>
    <div>
        <div class="content-caption dashed">
            <span>基础信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>保养业务单元</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.shopName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>机构标签</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.shopTagName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务单元联系人</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.retailerShopContactName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>机构联系电话</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.retailerShopContractTel}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否周期保养</label>
                </div>
                <div class="form-value">
                    <span v-if="deviceMaintPlan.cronFlag">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center" v-if="deviceMaintPlan.cronFlag">
                <div class="form-label">
                    <label>周期说明</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.theExprDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>下次保养执行时间</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.theDateTime}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="deviceMaintPlan.cronFlag">
                <div class="form-label">
                    <label>保养截止时间</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.limitEndTime || '无'}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>保养资产</span>
            <div style="position: absolute;top: 10px;right: 10px;color: #555;font-size: 13px;">共{{deviceMaintPlanItemList.length}}条</div>
        </div>
        <div class="table-layout">
            <el-table :data="deviceMaintPlanItemList" border style="width: 100%" class="mt5">
                <el-table-column prop="deviceName" width="250" label="资产描述全称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="deviceMaintPlan.suitFlag" prop="suitName" width="250" label="套装名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="tmpNo" width="250" label="系统编号"></el-table-column>
                <el-table-column align="left" prop="shopDevice.wrntDueTime" width="150" label="质保到期时间"></el-table-column>
                <el-table-column prop="sellerName" label="供应商名称" align="left" width="150" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span :title="roleMerchtVendor(rows.row.shopDevice)">{{ roleMerchtVendor(rows.row.shopDevice) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="servicerName" label="服务商名称" align="left" width="150" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span :title="roleMerchtServicer(rows.row)">{{ roleMerchtServicer(rows.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="servcTitle" label="服务" align="left" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="execDateTime" label="已执行时间" align="left" width="150"></el-table-column>
                <el-table-column v-if="deviceMaintPlan.cronFlag" prop="yqFinishTime" label="下次工单截止时间" align="center" width="130"></el-table-column>
                <el-table-column v-if="!deviceMaintPlan.cronFlag" prop="yqFinishTime" label="工单截止时间" align="center" width="130"></el-table-column>
                <el-table-column v-if="deviceMaintPlan.cronFlag" prop="yqFinishHours" label="要求完成小时" align="right" width="130"></el-table-column>
                <el-table-column prop="yqFinishAotHr" label="提前预警小时" align="right" width="100"></el-table-column>
                <el-table-column width="180" label="操作" align="left" fixed="right">
                    <template slot-scope="rows">
                        <a class="font14 swb-btn-link" v-if="checkActionPerm('maint_plan_rec')" @click="showDeviceRepairRec(rows.row.tmpNo)">保养记录</a>
                        <a class="font14 swb-btn-link" v-if="deviceMaintPlan.suitFlag" @click="showDeviceSuit(rows.row.suitId)">套装信息</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils, Routes } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import appConf from '../../app.conf';
    import { checkUserActionPerm } from '../index'
    import { openServicerSelectComnDlg } from '../servicer/selectDlg'
    import { openMsuListByGoodsCatIdDlg } from '../servc/selectDlg'
    import { openDeviceRepairRecDlg } from '../workVoucher/showDetailDlg'
    import { setPlanYqInfoDlg } from './dialog'
    //
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'
    import contractApi from '../../api/contract'

    import SwbDeviceMaintPlanList from './DeviceMaintPlanList'
    Vue.regist(SwbDeviceMaintPlanList);

    import SwbShopDeviceSuitDetail from './ShopDeviceSuitDetail';
    Vue.regist(SwbShopDeviceSuitDetail);

    import SwbShopDeviceList from '../devc/ShopDeviceList';
    Vue.regist(SwbShopDeviceList);
    //
    export default {
        name: 'swb-device-maint-plan-detail',
        path: '',
        avlScopes: 'retailer',
        desc: '门店资产保养详情',
        props: {
            id: {
                type: Number
            }
        },
        data: function () {
            return {
                deviceMaintPlan: {},
                deviceMaintPlanItemList: [],
                currentDate: (new Date()).format("yyyy-MM-dd"),
                //
                updateFlag: false
            }
        },
        created: function () {
            this.getDeviceMaintPlan();
        },
        methods: {
            checkActionPerm: function (action) {
                return checkUserActionPerm(SwbDeviceMaintPlanList.path, action, null);
            },
            getDeviceMaintPlan: function () {
                let self = this;
                let postData = {
                    id: self.id
                };
                let msgBoxDlg = MsgBox.loading();
                devcApi.getDeviceMaintPlanDetail(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let deviceMaintPlan = result.data;
                        self.deviceMaintPlan = deviceMaintPlan;
                        let theDateTime = deviceMaintPlan.theDateTime;
                        if(theDateTime != null) {
                            self.currentDate = theDateTime.format("yyyy-MM-dd");
                        }
                        //
                        self.deviceMaintPlanItemList = self.deviceMaintPlan.itemList || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showDeviceRepairRec: function (tmpNo) {      // 查看维保记录
                //
                openDeviceRepairRecDlg(tmpNo, false, true, this.id);
            },
            checkWrnt(deviceSubNo){
                return (deviceSubNo.wrntDueTime == null || (deviceSubNo.wrntDueTime != null && deviceSubNo.wrntDueTime.format('yyyy-MM-dd') >= this.currentDate)) && !deviceSubNo.imported;
            },
            checkRoleMerchtVendor(deviceSubNo){
                return this.checkWrnt(deviceSubNo) && deviceSubNo.sellerType != this.merchantServicer;
            },
            roleMerchtVendor(deviceSubNo){
                if(this.checkRoleMerchtVendor(deviceSubNo)) {
                    return deviceSubNo.sellerName || '无';
                }
                return '';
            },
            roleMerchtServicer(maintPlanDevc){
                if(Utils.isNoB(maintPlanDevc.servicerId)) {
                    // 兼容-老数据，为冗余服务商的数据
                    let deviceSubNo = maintPlanDevc.shopDevice;
                    if(this.checkWrnt(deviceSubNo)) {
                        if(deviceSubNo.sellerType == this.merchantServicer) {
                            return deviceSubNo.sellerName || '无';
                        }
                    } else {
                        return deviceSubNo.defServicerName || '无';
                    }
                } else {
                    return maintPlanDevc.servicerName;
                }
            },
            showDeviceSuit: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: "资产套装详情",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-suit-detail :id="id" :toShopDeviceList="toShopDeviceList"></swb-shop-device-suit-detail>' +
                    '</div>',
                    data: {
                        id: id
                    },
                    methods: {
                        toShopDeviceList: function (no) {
                            self.toShopDeviceList(no);
                        }
                    },
                });
            },
            toShopDeviceList(no) {
                let data = {
                    tmpNo: no
                };
                let hashUrl = Utils.makeUrl(SwbShopDeviceList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceMaintPlanDetail.vue